<template>
    <div id="app">
        <navbar :logo="logo" :logo_style="logo_style"></navbar>
        <router-view/>
        <el-footer height="40px">For additional assistance please email <a :href="`mailto: ${email}`" style="color: #ffd141">{{ email }}</a></el-footer>
    </div>
</template>

<script>
    import Navbar from "./components/common/Navbar";
    import api from "@/services/api";
    import {
        DOMAIN_OVERRIDES,
        DEFAULT_EMAIL,
        DEFAULT_LOGO,
        DEFAULT_STYLE,
        DEFAULT_BODY_OVERLOAD
    } from '@/components/utils/constants'

    export default {
        name: "App",
        components: {Navbar},
        data() {
            return {
                email: (DOMAIN_OVERRIDES[window.location.host] && DOMAIN_OVERRIDES[window.location.host].email) || DEFAULT_EMAIL,
                logo: (DOMAIN_OVERRIDES[window.location.host] && DOMAIN_OVERRIDES[window.location.host].logo) || DEFAULT_LOGO,
                logo_style: (DOMAIN_OVERRIDES[window.location.host] && DOMAIN_OVERRIDES[window.location.host].logo_style) || DEFAULT_STYLE,
            }
        },
        methods: {
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body;

                if (addRemoveClass === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            },
        },
        mounted() {
            let className = (DOMAIN_OVERRIDES[window.location.host] && DOMAIN_OVERRIDES[window.location.host].body_class) || DEFAULT_BODY_OVERLOAD;
            if (!className) return;
            this.toggleBodyClass('addClass', className);
        },
        destroyed() {
            let className = (DOMAIN_OVERRIDES[window.location.host] && DOMAIN_OVERRIDES[window.location.host].body_class) || DEFAULT_BODY_OVERLOAD;
            if (!className) return;
            this.toggleBodyClass('removeClass', className);
        },
        created() {
            api.interceptors.response.use(undefined, function (err) {
                return new Promise(function () {
                    if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
                        this.$store.dispatch("logout")
                    }
                    throw err;
                });
            });
        }
    };
</script>
<style>
    @import 'https://fonts.googleapis.com/css?family=Raleway:100,200,300,400,500,600,700,800,900';
</style>

<style lang="scss">


    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        --md-theme-default-primary-on-background: #545c64;
        --md-theme-default-primary: #545c64;
        --md-theme-default-accent: #545c64;
    }

    html, body {
        margin: 0;
        --md-theme-default-primary-on-background: #545c64;
        --md-theme-default-primary: #545c64;
        --md-theme-default-accent: #545c64;
    }

    * {
        font-family: "Raleway";
    }

    body {
            background-repeat: no-repeat;
            background-size: 100% 100%;
    }

    .widevoice-body {
        background-image: url("~@/assets/widevoice_bg_gradient.png");
    }

    .carrierx-body {
        background-image: url("~@/assets/cx-login-sellbox.jpg");
    }

    .el-footer {
        background-color: #545c64;
        color: #fff;
        position: fixed;
        z-index: 1;
        text-align: center;
        bottom: 0;
        line-height: 40px;
        width: 100%;
        font-weight: 500;
    }

</style>
